import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Environment } from 'src/environments/environment.interface';

export interface PartsFormConfigOptions {
  translate: TranslateService;
  environment: Environment;
}

export function createPartsFormConfig(options: PartsFormConfigOptions): FormlyFieldConfig[] {
  const { translate, environment } = options;

  return [
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-4',
          type: 'input',
          key: 'name',
          props: {
            label: translate.instant('doctrine.part.name'),
            required: true,
            maxLength: environment.maxStringLength,
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
        {
          className: 'col-4',
          type: 'input',
          key: 'code',
          props: {
            label: translate.instant('doctrine.part.code'),
            required: true,
            maxLength: environment.maxStringLength,
          },
          expressionProperties: {
            'props.disabled': `false`
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
      ],
    },
    {
      className: 'section-label',
      template: '<div><strong>' + translate.instant('admin.part.show.supplier') + '</strong></div><hr />',
    },
    {
      fieldGroupClassName: 'row',
      key: 'supplierPart',
      fieldGroup: [
        {
          className: 'col-4',
          type: 'input',
          key: 'name',
          props: {
            label: translate.instant('doctrine.part.supplierName'),
            required: true,
            maxLength: environment.maxStringLength,
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
        {
          className: 'col-4',
          type: 'input',
          key: 'contactPerson',
          props: {
            label: translate.instant('doctrine.part.contactPerson'),
            required: true,
            maxLength: environment.maxStringLength,
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
        {
          className: 'col-4',
          type: 'input',
          key: 'email',
          props: {
            label: translate.instant('doctrine.part.email'),
            required: true,
            maxLength: environment.maxStringLength,
            pattern: environment.emailPattern,
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      key: 'supplierPart',
      fieldGroup: [
        {
          className: 'col-4',
          type: 'input',
          key: 'supplierPartName',
          props: {
            label: translate.instant('doctrine.part.supplierPartName'),
            required: true,
            maxLength: environment.maxStringLength,
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
        {
          className: 'col-4',
          type: 'input',
          key: 'supplierPartCode',
          props: {
            label: translate.instant('doctrine.part.supplierPartCode'),
            required: true,
            maxLength: environment.maxStringLength,
          },
          validation: {
            messages: {
              pattern: translate.instant('errors.invalid'),
              required: translate.instant('errors.required'),
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
      ],
    },
    {
      fieldGroupClassName: 'row',
      key: 'supplierPart',
      fieldGroup: [
        {
          className: 'col-12',
          type: 'textarea',
          key: 'remark',
          props: {
            label: translate.instant('doctrine.part.remark'),
            required: false,
            maxLength: environment.maxStringLength,
            rows: 4,
          },
          validation: {
            messages: {
              maxlength: (_, field: FormlyFieldConfig) => translate.instant('validators.max_message',
                {limit: field.props?.maxLength})
            },
          },
        },
      ],
    },
    {
      className: 'section-label',
      template: '<div><strong>' + translate.instant('admin.part.other') + '</strong></div><hr />',
    },
    {
      fieldGroupClassName: 'row',
      fieldGroup: [
        {
          className: 'col-4',
          type: 'input',
          key: 'stockAmount',
          props: {
            label: translate.instant('doctrine.part.stockAmount'),
            required: true,
            type: 'number',
            min: 0,
          },
          validation: {
            messages: {
              required: translate.instant('errors.required'),
              min: translate.instant('errors.invalid'),
            },
          },
        },
      ],
    },
  ];
} 